import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const useCanSubmitDrawRequestAlphaCustomers = () => {
  const { fundingRequestV2AlphaDrawPermissions } = useFeatureFlags();

  return {
    canUserOrgSubmitDrawRequest:
      fundingRequestV2AlphaDrawPermissions !== 'deny',
    canUserOrgSubmitGlobalDrawRequest:
      fundingRequestV2AlphaDrawPermissions === 'allow' ||
      fundingRequestV2AlphaDrawPermissions === 'globalOnly',
    canUserOrgSubmitClassDrawRequest:
      fundingRequestV2AlphaDrawPermissions === 'allow' ||
      fundingRequestV2AlphaDrawPermissions === 'classOnly',
  };
};

export const useCanSubmitRecycleRequestAlphaCustomers = () => {
  const { fundingRequestV2AlphaRecyclePermissions } = useFeatureFlags();

  return {
    canUserOrgSubmitRecycleRequest: fundingRequestV2AlphaRecyclePermissions,
  };
};
